


export const tiptap_doc_id = 'f767314b-f10a-4c17-a094-aba7e6287544'

export const JsonStrView = ({ data }) => <div><h3>JSON Data</h3><pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowX: 'auto'}}>{ data && JSON.stringify(data, null, 2)}</pre></div>;
// export const HtnlStrView = ({ data }) => <div><h3>HTML Data</h3><pre style={{whiteSpace: 'pre-wrap', wordWrap: 'break-word', overflowX: 'auto'}}>{ ttData && generateHTML(data, tt_extensions )}</pre></div>;
